<template lang="html">
  <!-- TODO: separate create overlay and edit over with methods -->

  <div class="variety">

    <HeadedContainer>
      <template v-slot:header>
        <div class="head">
          <span>{{$ml.get(`Types`)}}</span>

          <AddBtn @click="enableAdd" v-if="$store.getters['crop/base'].owner != 0"/>
        </div>
      </template>
      <div class="data">

        <div v-if="!parent.id" class="no-data">
          {{$ml.get(`No base crop created`)}}
        </div>

        <div v-else-if="!items.length" class="no-data">
          {{$ml.get(`There are no any types`)}}
        </div>

        <div v-else class="scroller">
          <SelectorOverlayContainer
            :react-on="items"
            :value="selected"
            key-name="id"
          >
            <SelectorOverlayItem
              v-for="item in items"
              :key="item.id"
            >
              <div class="item" :data-type="item.name">
                <button
                  @click="select(item)"
                  class="--selector-overlay-pointer h-empty-btn item-inside"
                  :class="{ selected: selected.id == item.id }"
                >
                    <span>{{ $ml.get(item.name) }}</span>
                  <MoreActions
                    v-if="selected.id == item.id && $store.getters['crop/base'].owner != 0"
                    @remove="remove"
                    @edit="enableEdit"
                  />
                </button>
              </div>
            </SelectorOverlayItem>
          </SelectorOverlayContainer>
        </div>

        <transition name="modal-fade-scale">
          <VarietyCreate
            @update="sync"
            @close="disableAdd"
            v-if="adding_enabled"
          />
        </transition>

        <transition name="modal-fade-scale">
          <VarietyEdit
            @update="sync"
            @close="disableEdit"
            v-if="edit_enabled"
          />
        </transition>

      </div>
    </HeadedContainer>

  </div>
</template>

<script>
import { CropAPI } from '@/api'
import VarietyCreate from './VarietyCreate'
import VarietyEdit from './VarietyEdit'
import { mapGetters } from 'vuex';
import {
  SelectorOverlayContainer,
  SelectorOverlayItem
} from '@/components/common/selector-overlay'
import HeadedContainer from '@/components/common/HeadedContainer';
import AddBtn from './AddBtn';
import EditBtn from './EditBtn';
import MoreActions from './MoreActions';

export default {
  components: {
    SelectorOverlayContainer,
    SelectorOverlayItem,
    VarietyEdit,
    VarietyCreate,
    HeadedContainer,
    AddBtn,
    EditBtn,
    MoreActions,
  },

  data() {
    return {
      adding_enabled: false,
      edit_enabled: false,
    };
  },

  methods: {

    remove() {
      return CropAPI.deleteCropVariety(this.selected.id).then(res => {
        this.sync();
      });
    },

    sync(item = null) {
      this.$store.dispatch('crop/updateVarieties');
      if(item) return this.select(item);
    },

    enableAdd() {
      this.adding_enabled = true;
    },

    disableAdd() {
      this.adding_enabled = false;
    },

    enableEdit(item) {
      this.edit_enabled = true;
    },

    disableEdit() {
      this.edit_enabled = false;
    },

    select(item) {
      return this.$store.dispatch('crop/selectVariety', item.id);
    },
  },

  computed: {
    ...mapGetters({
      selected: 'crop/variety',
      items: 'crop/varieties',
      parent: 'crop/base',
    }),
  },
}
</script>

<style lang="scss" scoped>

.variety {
  position: relative;

  display: flex;
  flex-direction: column;

  .headed-container {
    height: 100%;
  }

  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;
  }

  .no-data {
    display: flex;
    align-items: center;
    justify-content: center;

    color: #ddd;
    flex-grow: 1;
    padding: 30px 0;
    width: 100%;
    height: 100%;
  }

  .scroller {
    display: flex;
    align-items: stretch;
    flex-direction: column;

    position: relative;
    padding-top: 20px;
    overflow: auto;
    max-width: 100%;
    height: 100%;
  }

  .data {
    background: #FFFFFF;
    border-radius: 0px 0px 5px 5px;
    position: relative;
    overflow: hidden;

    height: 100%;
    width: 100%;

    .item {
      padding: 0 10px;

      .item-inside {
        width: 100%;
        position: relative;
        padding: 10px 20px;
        color: #4C5056;
        font-size: 16px;
        font-weight: bold;
        text-align: left;
        transition: color 0.5s ease;

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        &.selected {
          color: #fff;

        }

        &:hover {
          .edit-btn {
            display: flex;
          }
        }
      }
    }
  }
}

</style>
